var map = {
	"./betocarreiro.jpg": "716e",
	"./cidadedasabelhas.jpg": "9bb6",
	"./cinepolis.jpg": "7b34",
	"./hellopark.jpg": "e1b2",
	"./hopihari.jpg": "c651",
	"./parquedamonica.jpg": "e359",
	"./playland.jpg": "9437",
	"./snowland.jpg": "c75f",
	"./thermasdoslaranjais.jpg": "7a98",
	"./thermaswaterpark.jpg": "1765",
	"./zoosp.jpg": "0376"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3b35";